/* istanbul ignore file  */
const _strings = {
  'katal-carousel-default-aria-label': {
    'en-US': 'Carousel of items below',
  },
  'katal-carousel-default-image-link-label': {
    'en-US': 'Read More',
  },
};

export default _strings;
